import { createAsyncThunk } from '@reduxjs/toolkit';

import axios from 'axios'; // Or your preferred HTTP client
import {LargeDataAnalyticsHostname} from "../../configs/Domain";

const API_BASE_URL = LargeDataAnalyticsHostname; // Or your configured base URL

export const createApiAsyncThunk = (
  typePrefix, // Unique identifier for the thunk (e.g., 'analysis/cluster')
  endpoint,    // API endpoint path (e.g., '/analysis/cluster')
  method = 'GET' // HTTP method (GET, POST, etc.)
) => {
  return createAsyncThunk(
    typePrefix,
    async (params, { rejectWithValue }) => {
      try {
        const config = {
          method,
          url: `${API_BASE_URL}${endpoint}`,
          params: method === 'GET' ? params : undefined, // Query parameters for GET
          data: method !== 'GET' ? params : undefined,   // Request body for other methods (POST, PUT)
        };

        const response = await axios(config);
        return response.data;
      } catch (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          return rejectWithValue(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          return rejectWithValue('No response received from server.');
        } else {
          // Something happened in setting up the request that triggered an Error
          return rejectWithValue('Error setting up the request.');
        }
      }
    }
  );
};

export const fetchClusterData = createApiAsyncThunk(
  'analysis/cluster', // typePrefix
  '/analysis/cluster', // endpoint
  'GET'                // method
);
